import { type Maybe } from '@models/Maybe';
import { formatDate } from '@utils/dateFormatUtils';

export function hasNumericValue(value: unknown): value is number {
    return typeof value === 'number';
}

export function formatBoolean(value: Maybe<boolean>): string {
    if (value === null || value === undefined) return '-';
    return value ? 'Yes' : 'No';
}

export function formatDateOrDash(value: Maybe<string>): string {
    const formatted = formatDate(value);
    return formatted === '' ? '-' : formatted;
}

export function formatScore(value: Maybe<number>): string {
    if (value === null || value === undefined) return '-';
    return value.toFixed(1);
}
